import React from 'react';
import { ChevronLeft, Bell, Stethoscope } from 'lucide-react';

export default function TopBar({ activeTab }) {
  return (
    <header className="top-bar">
      <div className="top-bar-left">
        <div className="breadcrumb">
          <span className="breadcrumb-main">لوحة التحكم</span>
          <ChevronLeft size={14} />
          <span className="breadcrumb-current">
            {activeTab === 'bookings' ? 'الحجوزات' : 'المحادثات'}
          </span>
        </div>
      </div>
      <h1 className="page-title">
        {activeTab === 'bookings' ? 'إدارة الحجوزات' : 'المحادثات المباشرة'}
      </h1>
      <div className="top-actions">
        {/* <button className="icon-btn notification-btn" aria-label="إشعارات">
          <Bell size={20} />
          <span className="notif-badge">3</span>
        </button> */}
        <div className="user-pill">
          <div className="user-avatar-small">
            <Stethoscope size={14} />
          </div>
          <span>د. محمد خالد توفيق</span>
        </div>
      </div>
    </header>
  );
}
